export default __webpack_public_path__ + "/dist/images/privacy-inactive.a21d9bf1966788520460a1bf6a3a3bcd.svg";